import React, { useEffect, useRef } from 'react';

import { mount, unmount } from 'redom';

import NativeSecondaryControls from './';

function NativeSecondaryControlsReactWrapper(props) {

  const wrapperMainReference = useRef(null);
  const nativeSecondaryControlsReference = useRef(null);

  useEffect(function onLoad() {

    const container = wrapperMainReference.current;

    const nativeSecondaryControls = new NativeSecondaryControls(props);

    nativeSecondaryControlsReference.current = nativeSecondaryControls;

    mount(container, nativeSecondaryControlsReference.current);

    return function onUnload() {

      unmount(container, nativeSecondaryControls);

    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(function onPropsChange() {

    nativeSecondaryControlsReference.current.update(props);

  }, [props]);

  function renderMain() {

    const mainAttributes = {
      className: 'secondary-controls-native-react-wrapper-main',
      ref: wrapperMainReference
    };

    return <div {...mainAttributes}>
    
    </div>;

  }

  return renderMain();

}

export default NativeSecondaryControlsReactWrapper;